module.exports = {
    api: {
        // All paginated queries will use this per page value
        perPageDefault: 12
    }
};
